import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { House } from 'react-bootstrap-icons';
export default function HeaderSectionLoading(props) {
	const { /* title, */ subtitle, button, colection, collage } = props;
	//console.log(props);
	return (
		<Container>
			<div className='c-top-header-section loading'>
				<div className='c-top-header-container'>
					<div className='c-top-header-title animated'>
						<h1>...</h1>
					</div>
					{!button && !collage && (
						<div className='c-divisor'>
							<div className='c-line'></div>
						</div>
					)}
					{!button && collage && (
						<ul>
							<li key={0}>
								<Link to={'#'}>
									<House />
								</Link>
							</li>
							<li key={1} className='animated'>
								<Link to={'#'}>...</Link>
							</li>
							<li key={2} className='animated'>
								<Link to={'#'}>...</Link>
							</li>
						</ul>
					)}
				</div>
			</div>
			{button && !collage && (
				<div className='c-top-header-section-button'>
					<div className='c-top-header-container'>
						{subtitle && (
							<div className='c-top-header-subtitle'>
								<div className='loaderx'> </div>
							</div>
						)}
						<div className='c-top-header-title'>
							<h1>
								<div className='loaderx'> </div>
							</h1>
						</div>
						<div className='c-divisor'>
							<div className='c-line'></div>
						</div>
					</div>
					<div className='c-top-header-button'>
						<div>
							{colection && (
								<Button
									variant='outline-primary'
									className='c-button'
								>
									<div className='loaderx'> </div>
								</Button>
							)}
						</div>
					</div>
				</div>
			)}
		</Container>
	);
}
